export default {
    key: 'winteregg-muerren',
    common: {
        productName: 'core.productNames.winteregg-muerren',
        splashMessage: 'offerFlow.splashMessage.winteregg-muerren',
        headingAside: 'offerFlow.headingAside.winteregg-muerren',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.winteregg-muerren',
    },
    stepTripSelection: {
        heading: 'offerFlow.pages.stepTripSelection.heading.common',
        body: 'offerFlow.p2p.dayTicket',
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.p2p',
        body: 'offerFlow.pages.stepPassengers.body.withReductions',
    },
} satisfies OfferFlowContent;
